import { Box } from '@mui/material';
import { getApplicationReportAction } from '~/components/ApplicationReports/constants.ts';
import { TApplicationReportContent } from '~/components/ApplicationReports/types.ts';
import { styles } from '~/components/ApplicationReports/styles.ts';
import { ActionsButton } from '~/components/ApplicationReports/components/table/ActionsButton.tsx';

interface IApplicationReportActionCellProps {
  row: TApplicationReportContent;
  pendingActionId: string | null;
  onArchive: (row: TApplicationReportContent) => void;
  onRestore: (row: TApplicationReportContent) => void;
  onVerification: (row: TApplicationReportContent) => void;
  status: string;
}

export const ApplicationReportActionCell = ({
  row,
  pendingActionId,
  onArchive,
  onRestore,
  onVerification,
  status,
}: IApplicationReportActionCellProps) => {
  const action = getApplicationReportAction(row.status);

  if (!action) {
    return null;
  }

  const isPending = pendingActionId === String(row.applicationId);

  const handleArchive = () => {
    if (isPending) return;
    onArchive(row);
  };

  const handleRestore = () => {
    if (isPending) return;
    onRestore(row);
  };

  const handleVerification = () => {
    if (isPending) return;
    onVerification(row);
  };

  return (
    <Box sx={styles.applicationReportButton}>
      <ActionsButton
        onArchive={handleArchive}
        onRestore={handleRestore}
        onVerification={handleVerification}
        status={status}
      />
    </Box>
  );
};
